import React, { useCallback, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import '../../../css/components/batches/DetailsHeader.css';

import Traductor from '../../Traductor';
import { ReactComponent as TrolleyIcon } from '../../../images/icons/trolley.svg';
import NotificationBox from '../NotificationBox';

const DetailsHeader = ({
    name,
    onDeleteBatch,
    onAddVehiclesToBatch,
    onShowEdit,
    disabledAdd,
    batchStatus,
}) => {
    const t = useMemo(() => new Traductor(), []);
    const isDesktopOrTablet = useMediaQuery({
        query: '(min-device-width: 768px)',
    });

    const renderWarning = useCallback(() => {
        if (batchStatus === '2' || batchStatus === '4') return;

        if (batchStatus === '5') {
            return (
                <div className="o-layout__item u-3/4 u-1/1@s u-p-none u-pr u-pr-none@s u-mr u-mr-none@s u-mt-large u-mb">
                    <NotificationBox
                        type="warning"
                        message={t.getTraduction(
                            'BatchDetailsPendingHeaderWarning'
                        )}
                    />
                </div>
            );
        }

        return (
            <div className="o-layout__item u-3/4 u-1/1@s u-p-none u-pr u-pr-none@s u-mr u-mr-none@s u-mt-large u-mb">
                <NotificationBox
                    type="warning"
                    message={t.getTraduction('BatchDetailsActiveHeaderWarning')}
                />
            </div>
        );
    }, [batchStatus, t]);

    if (!name) {
        return (
            <div
                id="c-details-header-container"
                data-testid="detailsHeaderSkeletonTestId"
                className="u-1/1 u-p-none"
            >
                <span className="skeleton-details-title u-float-left u-1/3" />
                <div className="u-flex u-1/4 u-float-right">
                    <span className="skeleton-details-button u-3/6 u-mr-small" />
                    <span
                        className="skeleton-details-button u-3/6"
                        style={{ marginLeft: 'auto' }}
                    />
                </div>
            </div>
        );
    }

    return (
        <>
            <div
                id="c-details-header-container"
                className="o-layout__item u-1/1 u-p-none"
            >
                <h1 className="u-mb-none">{name}</h1>
                <button
                    className="c-btn--icon-only  c-btn--medium u-initial-button"
                    onClick={onShowEdit}
                    style={
                        isDesktopOrTablet
                            ? { marginRight: 'auto' }
                            : { marginLeft: 'auto' }
                    }
                >
                    <i className="c-btn__icon c-icon c-icon--[semantic-edit] u-text-brand" />
                </button>
                <div className="c-button-group  c-button-group--auto u-flex">
                    {isDesktopOrTablet ? (
                        <>
                            <button
                                className="c-btn  c-btn--link c-btn--simple u-mr u-flex u-p-none u-text-brand u-initial-button u-animated-outline-container"
                                disabled={batchStatus === '7'}
                                onClick={onDeleteBatch}
                            >
                                <i
                                    className={`c-btn__icon c-icon  c-icon--[bin]`}
                                />
                                <span
                                    className={`c-btn__text ${
                                        batchStatus === '7'
                                            ? ''
                                            : 'u-animated-outline-item'
                                    }`}
                                >
                                    {t.getTraduction('Eliminar')}{' '}
                                    {t.getTraduction('Lote')}
                                </span>
                            </button>
                            <button
                                className="c-btn  c-btn--secondary c-btn--icon u-pv-xsmall u-p-xsmall@s"
                                onClick={onAddVehiclesToBatch}
                                disabled={disabledAdd}
                            >
                                <span
                                    className="o-relative u-flex"
                                    style={{
                                        width: '1.71429rem',
                                        height: '1.71429rem',
                                    }}
                                >
                                    <TrolleyIcon
                                        id="c-trolley-icon"
                                        className="c-icon c-btn__icon"
                                        alt="Shopping cart icon"
                                        // width="1.71429rem"
                                        // height="1.71429rem"
                                    />
                                    <i
                                        id="c-trolley-icon-content"
                                        className="c-icon  c-icon--[semantic-zoom-in] u-round u-text-white test u-bg-brand disabled-hover"
                                    />
                                </span>
                                <span className="c-btn__text">
                                    {t.getTraduction('AddVehicles')}
                                </span>
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                className="c-btn c-btn--link c-btn--simple u-mr u-flex u-p-none u-text-brand u-initial-button u-animated-outline-container"
                                disabled={batchStatus === '7'}
                                onClick={onDeleteBatch}
                            >
                                <i
                                    className={`c-btn__icon c-icon  c-icon--[bin]`}
                                />
                            </button>
                            <button
                                className={`c-btn c-btn--icon-only c-btn--round ${
                                    disabledAdd ? '' : 'u-bg-brand'
                                }`}
                                style={{
                                    position: 'fixed',
                                    bottom: '16px',
                                    right: '16px',
                                    height: '50px',
                                    width: '50px',
                                    zIndex: 3,
                                    border: '0.5px solid white',
                                    padding: '8px',
                                }}
                                onClick={onAddVehiclesToBatch}
                                disabled={disabledAdd}
                            >
                                <TrolleyIcon
                                    id="c-trolley-icon"
                                    className="c-icon c-btn__icon"
                                    alt="Shopping cart icon"
                                    fill="white"
                                    stroke="white"
                                    opacity={disabledAdd ? 0.6 : 1}
                                />
                                <i
                                    id="c-trolley-icon-content"
                                    className="c-icon  c-icon--[semantic-zoom-in] u-round u-text-white test u-bg-brand disabled-hover"
                                    style={{
                                        border: disabledAdd
                                            ? '1px solid #D8D8D8'
                                            : '1px solid white',
                                        top: '10px',
                                        right: '16px',
                                        opacity: disabledAdd ? 0.6 : 1,
                                    }}
                                />
                            </button>
                        </>
                    )}
                </div>
            </div>
            {renderWarning()}
        </>
    );
};

DetailsHeader.propTypes = {
    name: PropTypes.string,
    onDeleteBatch: PropTypes.func.isRequired,
    onAddVehiclesToBatch: PropTypes.func.isRequired,
    onShowEdit: PropTypes.func.isRequired,
    disabledAdd: PropTypes.any,
    batchStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DetailsHeader;
